import React from 'react';
import { IngestWithContext } from '@wealthlane/chatbot';
import { axiosInstance } from '../../services/apiInterceptor';
import { useGetCurrentTenantInfo, useWealthlaneCustomerApi } from '../../hooks';
import { toast } from 'react-toastify';
import Heading from '../typography';
import { PageHeader, WrapperContainer } from '../../constants/style/common.styled';
import ToastComponent from '../toast';
import { useNavigate } from 'react-router-dom';
import useInstance from '../../hooks/custom-hooks/useInstance';

// Define TChatConfig type locally since it's not exported from @wealthlane/chatbot v0.1.7
type TChatConfig = {
  responseProtocol: string;
  responseType: string;
  endpoint?: string;
  timeout?: number;
  ingestionEndpoint?: string;
  disclaimer?: string;
};

export const configState: TChatConfig = {
  responseProtocol: 'websocket' as const as string,
  responseType: 'stream' as const as string,
  endpoint: process.env.REACT_APP_CHATBOT_WEBSOCKET_API,
  timeout: 30000,
  ingestionEndpoint: process.env.REACT_APP_INGESTION_ENDPOINT,
};

function IngestComponent() {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: currentTenantInfo } = useGetCurrentTenantInfo(handleRequest);
  const navigate = useNavigate();
  const { getCurrentCid } = useInstance();

  const cid = getCurrentCid();

  const sendMessage = (message: string) => {
    toast.success(message);
  };

  return (
    <>
      <IngestWithContext
        axiosInstance={axiosInstance}
        config={configState}
        navigate={navigate}
        companyId={cid?.toString?.() ?? ''}
        tenantIdAccessor={() => currentTenantInfo?.id}
        alertFunctionSuccess={(message: string) => {
          toast.success(<ToastComponent label='Success' message={message} />);
        }}
        alertFunctionError={(message: string) => {
          toast.error(<ToastComponent label='Error' message={message} />);
        }}
        metadataDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/metadata/list?status=uploaded`}
        createDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/generate-presigned-url`}
        previewDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/get-preview-presigned-url`}
        saveDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/publish`}
        documentListLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/list`}
        setAsActiveDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/version/rollback`}
        chunkPreviewLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/chunks`}
        suggestLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/suggest`}
        publishLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/publish`}
        taxonomyFacetsLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/taxonomy/facets`}
        taxonomyOptionsLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/taxonomy/options`}
        versionInfoLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/version/list?logical_id=`}
        promoteDocumentLink={`${process.env.REACT_APP_CHATBOT_REST_URL}/ingest/document/update-status`}
        allowPromote={true}
        allowTest={true}
        cid={cid.toString() ?? ''}
      />
    </>
  );
}

export const Ingest = IngestComponent;
